// extracted by mini-css-extract-plugin
export default {"pageTabs":"NavBar_pageTabs__vu9Cr","pageTab":"NavBar_pageTab__GiXS4","pageTab_active":"NavBar_pageTab_active__C6vue","pageTab_inactive":"NavBar_pageTab_inactive__wzO-g"};